import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { SuratJalanBateraiListComponent } from './list/surat-jalan-baterai-list.component';
import { SuratJalanBateraiRestService } from './surat-jalan-baterai-rest.service';
import { SuratJalanBateraiRoutingModule } from './surat-jalan-baterai-routing.module';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ChipComponent } from './components/chip/chip.component';
import { AddModalComponent } from './add-modal/add-modal.component';
import { DetailModalComponent } from './detail/detail-modal.component';
import { StatusInfoModal } from './status-info-modal/status-info-modal.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ModalComponent } from './components/modal/modal.component';
import { DraftModalComponent } from './draft-modal/draft-modal.component';
import { CustomMultiSelectComponent } from '../../libraries/custom-multi-select/custom-multi-select.component';
import { DrawerComponent } from '../../libraries/drawer/drawer.component';
import { ImgUploadV2Module } from '../../libraries/img-upload-v2/img-upload-v2.module';

export const PROVIDERS = [SuratJalanBateraiRestService];

@NgModule({
  imports: [
    SuratJalanBateraiRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    ImgUploadV2Module
  ],
  declarations: [
    ChipComponent,
    AddModalComponent,
    DetailModalComponent,
    StatusInfoModal,
    AccordionComponent,
    ModalComponent,
    SuratJalanBateraiListComponent,
    DraftModalComponent,
    CustomMultiSelectComponent,
    DrawerComponent,
  ]
})
export class SuratJalanBateraiModule {}
